import { z } from 'zod'

export const envString = z.string().min(1)
export const envUrl = z.url()
export const envOptionalString = z.string().optional()
export const envBooleanFlag = z.literal('true').optional()
export const envNodeEnv = z.enum(['development', 'production', 'test']).default('development')
export const envVercelEnv = z.enum(['development', 'preview', 'production']).optional()
export const envBrandId = z.enum(['wwjd', 'christspiracy']).optional()
export const envCrmWriteMode = z.enum(['mailchimp', 'fluentcrm', 'dual', 'duel']).optional()
